module.exports = __webpack_public_path__ + "img/qr_yjs.6e09a02a.jpg";